/* eslint-disable react/jsx-props-no-spreading */
import React, { Fragment } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { ErrorBoundry } from 'core.ui-module_site-components';

const PageLoader = (componentPath, menuItem, props) => {
  let PageComponent = null;
  if (menuItem?.menuItemTypeCode === 11) {
    PageComponent = React.lazy(
      () =>
        import(
          /* webpackChunkName: "pages" */
          /* webpackMode: "lazy" */
          '../pages/cms/CMSPage'
        )
    );
  } else {
    PageComponent = React.lazy(
      () =>
        import(
          /* webpackChunkName: "pages" */
          /* webpackMode: "lazy" */
          `../pages${componentPath}`
        )
    );
  }

  return (
    <ErrorBoundry>
      <React.Suspense fallback={<>Loading next...</>} key={uuidv4()}>
        <PageComponent menuItem={menuItem} {...props} />
      </React.Suspense>
    </ErrorBoundry>
  );
};

export default PageLoader;
